import React, { useId, useRef } from "react";
import { UncontrolledTooltip } from "reactstrap";
import { sentenceCase } from "../../util";
import { Unit } from "../../models/range.model";

const REF_SIZE = 20;
const HANDLE_SIZE = 18;

type Direction = "ltr" | "rtl";

interface Props {
  referenceMarkers: { value: number; key: string; unit: Unit }[];
  direction: Direction;
  min: number;
  max: number;
}
export const ReferenceMarkers = ({
  referenceMarkers,
  direction,
  min,
  max,
}: Props) => {
  return (
    <>
      <div
        className="sliderReferenceMarkers"
        style={{
          position: "absolute",
          width: `calc( 100% - ${HANDLE_SIZE}px)`,
          marginTop: -3,
          height: REF_SIZE,
          left: HANDLE_SIZE / 2,
        }}
      >
        {referenceMarkers.map(({ value, key, unit }) => {
          const position = getPercentFromLeft(value, direction, min, max);
          return (
            <ReferenceMarker
              key={position}
              value={value}
              position={position}
              type={key}
              unit={unit}
            />
          );
        })}
      </div>
    </>
  );
};

interface MarkerProps {
  value: number;
  position: number;
  type: string;
  unit: Unit;
}

export const ReferenceMarker = ({
  value,
  position,
  type,
  unit,
}: MarkerProps) => {
  const markerRef = useRef<HTMLDivElement>(null);
  const id = useId();

  const isWeight = unit === "g" || unit === "KG";

  return (
    <div
      id={id}
      ref={markerRef}
      className={`hand position-absolute reference-marker reference-marker-${type}`}
      style={{
        width: REF_SIZE,
        left: `calc(${position}% - ${REF_SIZE / 2}px)`,
        zIndex: 2,
        top: 3,
      }}
    >
      <svg width={`${REF_SIZE}px`} viewBox={`0 0 ${REF_SIZE} ${REF_SIZE}`}>
        <polygon
          points={`${REF_SIZE / 2} 0, ${REF_SIZE} ${REF_SIZE}, 0 ${REF_SIZE}`}
          fill="currentColor"
        />
      </svg>
      <UncontrolledTooltip
        target={markerRef}
        placement="top"
        container={markerRef}
      >
        {sentenceCase(type)}:{" "}
        <span className="lead">
          {value * (isWeight ? 1 : 100)}
          {isWeight ? unit : "%"}
        </span>
      </UncontrolledTooltip>
    </div>
  );
};

const getPercentFromLeft = (
  value: number,
  direction: Direction,
  min: number,
  max: number
) => {
  if (direction === "ltr") {
    return Math.round(((value - min) / (max - min)) * 100);
  }
  return 100 - Math.round(((value - min) / (max - min)) * 100);
};
